var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mt-3 w-100"},[_c('div',{staticClass:"card-body text-center"},[_c('div',[_vm._v("You need a subscription to see website visitors")]),_vm._v(" "),_c('div',{staticClass:"pt-3 pb-2"},[_c('a',{staticClass:"btn btn-success px-4",attrs:{"href":"/subscriptions"}},[_vm._v("Subscribe")])])])])
}]

export { render, staticRenderFns }